<!--
  新建 采购单特殊字段
  prop:
    item: 绑定对象
    form: form表单数据对象
    moduleName: 所属模块
  emit:
    showProduct: 打开关联商品弹窗
 -->

<template>
  <div class="redundant">
    <!-- 选择供应商 -->
    <template v-if="item.attr === 'supplierId'">
      <associated-field
        ref="associatedField"
        :module="'supplier'"
        :item="item"
        :form="form"
        @getSupplier="getSupplier"
        @emitObj="supplierChange"
        @addNew="addNew">
      </associated-field>
    </template>
    <!-- 采购负责人 -->
    <template v-else-if="item.attr === 'signerId'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
    </template>
    <!-- 关联产品 -->
<!--     <template v-else-if="item.attr === 'products' && form.supplierId">
      <div class="products type2">
        <input type="text" placeholder="暂无关联产品" :value="Products.productList | productLen" class="v-input" readonly>
        <div class="v-area">
          <template v-if="Products.productList.length">总价：{{totalPrice}}元；折扣：{{Products.discount}}% ；其它费用：{{Products.otherCharge}}元</template>
          <template v-else>总价：0元；折扣：0% ；其它费用：0元</template>
        </div>
        <span class="add-btn" @click="emitParent">选择</span>
      </div>
    </template> -->
    <!-- 采购产品 -->
<!--     <template v-else-if="item.attr === 'products'&& form.supplierId">
      <link-product :item="item" :form="form" :attrValue="item.attrValue" @emitProduct="getProduct"></link-product>
    </template>   -->

    <!-- 付款计划 -->
    <template v-else-if="item.attr === 'payPlan'">
      <v-payplan
        :attrValue="form[item.attr]"
        :payPlanType="item.payTypeArray"
        :item="item"
        @emitPayPlan="getPayPlan">
      </v-payplan>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import remoteSelect from '../remote-select'
import vPayplan from '../pay-plan'
// import linkProduct from '../linkProduct'
import vManager from '../manager'
import associatedField from '../associated-field'

// let initProducts = {
//   productList: [],
//   discount: 100,
//   otherCharge: 0
// }

export default {
  props: ['item', 'form', 'moduleName', 'instockproduct'],
  created () {
    console.log(this.selectProducts)
  },
  data () {
    return {
      // products: this.form.products || initProducts,
      // productList: []
      // discount: 100,
      // otherCharge: 0
      // productList: this.selectProducts || [],
      // tableProList: []
    }
  },
  computed: {
    ...mapGetters([
      'selectProducts'
    ])
  },
  methods: {
    ...mapActions([
      'setSupplierId',
      'setAttr'
    ]),
    emitParent () {
      this.$emit('showProduct')
    },
    getPayPlan (val) {
      Vue.set(this.form, 'payPlan', val)
    },
    // getProduct (val) {
    //   // 计算返回要保存的产品信息
    //   let productList = []
    //   val.map((obj) => {
    //     let proObj = {}
    //     proObj.id = obj.id
    //     obj.result.map((item) => {
    //       if (item.attr === 'num') {
    //         proObj.num = item.attrValue
    //       }
    //       if (item.attr === 'productPrice') {
    //         proObj.productPrice = item.attrValue
    //       }
    //     })
    //     productList.push(proObj)
    //   })
    //   Vue.set(this.form.products, 'productList', productList)
    // },

    // 供应商变化时，清空关联产品
    supplierChange (obj) {
      // 正常流程则清空产品通知父组件改变了,但是待采购进来时候有this.item.purchaseType，代表产品和供应商强制关联，不清空产品
      this.$emit('supplierChange', this.item.purchaseType)
      if (obj) {
        this.setSupplierId(obj.id)
      }
    },

    getSupplier (arr) {
      console.log(arr)
      this.$emit('addNew', arr)
    },
    refresh () {
      this.$refs.associatedField.refresh()
    },

    addNew (obj) {
      this.$emit('addNew', obj)
    }
  },
  components: {
    remoteSelect,
    vManager,
    vPayplan,
    // linkProduct,
    associatedField
  },
  // filters: {
  //   productLen (arr) {
  //     if (arr.length) {
  //       return `已关联${arr.length}种产品`
  //     }
  //   }
  // },
  watch: {
    // form: {
    //   handler () {
    //     if (this.form.products) {
    //       this.form.products = this.form.products
    //     }
    //   },
    //   deep: true
    // },
    // tableProList: {
    //   handler () {
    //     if (this.tableProList) {
    //       this.form.products.productList = this.productList
    //       // this.$emit('tableProList', this.tableProList)
    //     }
    //   },
    //   deep: true
    // },
    moduleName: function () {
      console.log(this.moduleName)
    }
  }
}
</script>
<style lang="less">
.redundant {
  .el-button {
    &.del {
      color: #ff6161;
      border: none;
      background: none;
    }
    .proOther .el-input {
      margin-right: 30px !important;
      width: 160px;
    }
  }
  .el-table .cell {
    .numInput {
      width: 50px !important;
    }
    .el-icon-minus,
    .el-icon-plus {
      border: 1px solid rgb(191, 203, 217);
      padding: 2px;
    }
  }
}
</style>
<style lang="less" scoped>
@import "../../../assets/less/fieldtype-products.less";
</style>



// WEBPACK FOOTER //
// index.vue?5c0cae91